/* tslint:disable */

/**
 */
export class Ping {
    ip?: string;
}
